import Keycloak from 'keycloak-js'

const keycloak = Keycloak({
  url: 'https://keycloak.allnippon.net/',
  realm: 'Passport',
  clientId: 'passport-fe',
})

export default keycloak
